import store from '../../index'
import { TranslateApp } from 'i18n'
import App from 'app/index'

export default () => {
  return new Promise((resolve) => {
    store.dispatch('auth/CHECK_LOGIN_ACCESS').then(async () => {
      const { isLogged } = store.state.auth
      await TranslateApp(App)
      return resolve(isLogged)
    }).catch(async (error) => {
      console.error(error)
      await TranslateApp(App)
      return resolve(false)
    })
  })
}
